import { useDispatch, useSelector } from 'react-redux';
import { includeIngredients as includeIngredientsAction } from '../actions';
import { getIsIncluding, getIncludeError } from '../selectors';

/**
 * Includes ingredients from the New (Global) Ingredients view.
 *
 * @returns {[excludeIngredients, *, *]}
 */
const useIncludeIngredients = () => {
  const dispatch = useDispatch();
  const isIncluding = useSelector(getIsIncluding);
  const includeError = useSelector(getIncludeError);

  const includeIngredients = (itemCodes = []) => {
    if (itemCodes.length === 0) {
      return;
    }
    dispatch(includeIngredientsAction(itemCodes));
  };

  return [includeIngredients, isIncluding, includeError];
};

export default useIncludeIngredients;
